// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"163":"docs","443":"about"}[chunkId] || chunkId) + "-legacy." + {"163":"b112da1c","410":"69f7e070","443":"374ab15b","856":"91b62c7d"}[chunkId] + ".js";
};